import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, QueryList, ViewChildren, effect, inject, input, output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Product } from '../../models/product.model';
import { ProductsRepositoryService } from '../../services/products-repository.service';
import { ExploreButtonComponent } from '../explore-button/explore-button.component';

export enum ScrollAbleSectionIds {
  Description = 'Description',
  SimilarProducts = 'SimilarProducts',
  Accessories = 'Accessories',
  Specifications = 'Specifications',
  ProductsInBox = 'ProductsInBox',
  Features = 'Features',
  ProductDetails = 'ProductDetails',
  Downloads = 'Downloads',
  SponsoredProducts = 'SponsoredProducts',
  InfluencerReviews = 'InfluencerReviews',
  FrequentlyBoughtToTogether = 'FrequentlyBoughtToTogether',
  Images = 'Images',
  Videos = 'Videos',
  Questions = 'Questions',
  Reviews = 'Reviews',
  Highlights = 'Highlights'
}

export enum ScrollAbleSectionViewLabels {
  Description = 'Description',
  ProductDetails = 'Product Details',
  SponsoredProducts = 'Sponsored Products',
  SimilarProducts = 'Similar Products',
  Accessories = 'Accessories',
  Specifications = 'Specifications',
  ProductsInBox = 'Products In Box',
  Features = 'Features',
  InfluencerReviews = 'Influencer Reviews',
  Downloads = 'Downloads',
  Questions = 'Questions',
  Reviews = 'Reviews',
  Videos = 'Videos',
  Images = 'Images',
  FrequentlyBoughtToTogether = 'Frequently bought together',
  Highlights = 'Highlights'
}

export enum ScrollAbleSectionModelMapping {
  Description = 'Description',
  ProductDetails = 'Product Details',
  SponsoredProducts = 'Sponsored Products',
  SimilarProducts = 'Similar Products',
  Accessories = 'Accessories',
  Specifications = 'Specifications',
  ProductsInBox = 'Products In Box',
  Features = 'Features',
  InfluencerReviews = 'Influencer Reviews',
  Downloads = 'Downloads',
  Questions = 'Questions',
  Reviews = 'Reviews',
  Videos = 'Videos',
  Images = 'Images',
  FrequentlyBoughtToTogether = 'Frequently bought together'
}

@Component({
  standalone: true,
  selector: 'base-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    ExploreButtonComponent
  ]
})
export class ExploreComponent implements AfterViewInit {
  private productsRepositoryService = inject(ProductsRepositoryService);

  // Access ProductStateManager for signal-based product data
  get productStateManager() {
    return this.productsRepositoryService.getProductStateManager();
  }



  readonly productInput = input<Product>({} as Product);
  private _product = signal<Product>({} as Product);

  // Computed getter for backward compatibility
  get product() {
    return this._product();
  }

  // Signal-based state
  private readonly _exploreShouldBeVisible = signal<boolean>(true);

  @ViewChildren(ExploreButtonComponent) exploreButtonComponents!: QueryList<ExploreButtonComponent>;

  // Computed property for template access
  get exploreShouldBeVisible() {
    return this._exploreShouldBeVisible();
  }

  ScrollAbleSectionIds = ScrollAbleSectionIds;

  ScrollAbleSections: { value: ScrollAbleSectionIds, viewValue: ScrollAbleSectionViewLabels }[] = [
    { value: ScrollAbleSectionIds.Description, viewValue: ScrollAbleSectionViewLabels.Description },
    { value: ScrollAbleSectionIds.Accessories, viewValue: ScrollAbleSectionViewLabels.Accessories },
    { value: ScrollAbleSectionIds.Specifications, viewValue: ScrollAbleSectionViewLabels.Specifications },
    { value: ScrollAbleSectionIds.ProductsInBox, viewValue: ScrollAbleSectionViewLabels.ProductsInBox },
    { value: ScrollAbleSectionIds.Features, viewValue: ScrollAbleSectionViewLabels.Features },
    { value: ScrollAbleSectionIds.SimilarProducts, viewValue: ScrollAbleSectionViewLabels.SimilarProducts },
    { value: ScrollAbleSectionIds.SponsoredProducts, viewValue: ScrollAbleSectionViewLabels.SponsoredProducts },
    { value: ScrollAbleSectionIds.Images, viewValue: ScrollAbleSectionViewLabels.Images },
    { value: ScrollAbleSectionIds.Videos, viewValue: ScrollAbleSectionViewLabels.Videos },
    /* { value: ScrollAbleSectionIds.InfluencerReviews, viewValue: ScrollAbleSectionViewLabels.InfluencerReviews }, */
    { value: ScrollAbleSectionIds.Downloads, viewValue: ScrollAbleSectionViewLabels.Downloads }
    /* { value: ScrollAbleSectionIds.Questions, viewValue: ScrollAbleSectionViewLabels.Questions },
    { value: ScrollAbleSectionIds.Reviews, viewValue: ScrollAbleSectionViewLabels.Reviews } */
  ];

  // Update output to use Angular 20 output() function
  scrollToSection$ = output<ScrollAbleSectionIds>();

  constructor() {
    // Effect to handle productInput changes
    effect(() => {
      const productValue = this.productInput();
      if (productValue) {
        this._product.set(productValue);
      }
    });


    // Debug effect to check assets data
    effect(() => {
      const assets = this.productStateManager.assets();
      // Assets data is now available for reactive updates
    });
  }

  // ÃƒÆ’Ã‚Â¢Ãƒâ€¦Ã¢â‚¬Å“ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ Handle explore button visibility after view init (not in effect)
  ngAfterViewInit() {
    // Check visibility after view is initialized
    this._exploreShouldBeVisible.set(this.exploreButtonComponents.length > 1);
  }

  scrollToSection(sectionId: ScrollAbleSectionIds) {
    this.scrollToSection$.emit(sectionId);
  }
}

